import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const EnglishFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><rect x="1" y="4" width="30" height="24" rx="4" ry="4" fill="#071b65"></rect><path d="M5.101,4h-.101c-1.981,0-3.615,1.444-3.933,3.334L26.899,28h.101c1.981,0,3.615-1.444,3.933-3.334L5.101,4Z" fill="#fff"></path><path d="M22.25,19h-2.5l9.934,7.947c.387-.353,.704-.777,.929-1.257l-8.363-6.691Z" fill="#b92932"></path><path d="M1.387,6.309l8.363,6.691h2.5L2.316,5.053c-.387,.353-.704,.777-.929,1.257Z" fill="#b92932"></path><path d="M5,28h.101L30.933,7.334c-.318-1.891-1.952-3.334-3.933-3.334h-.101L1.067,24.666c.318,1.891,1.952,3.334,3.933,3.334Z" fill="#fff"></path><rect x="13" y="4" width="6" height="24" fill="#fff"></rect><rect x="1" y="13" width="30" height="6" fill="#fff"></rect><rect x="14" y="4" width="4" height="24" fill="#b92932"></rect><rect x="14" y="1" width="4" height="30" transform="translate(32) rotate(90)" fill="#b92932"></rect><path d="M28.222,4.21l-9.222,7.376v1.414h.75l9.943-7.94c-.419-.384-.918-.671-1.471-.85Z" fill="#b92932"></path><path d="M2.328,26.957c.414,.374,.904,.656,1.447,.832l9.225-7.38v-1.408h-.75L2.328,26.957Z" fill="#b92932"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
);

const ThaiFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><path fill="#282646" d="M1 11H31V21H1z"></path><path d="M5,4H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" fill="#992532"></path><path d="M5,20H27c2.208,0,4,1.792,4,4v4H1v-4c0-2.208,1.792-4,4-4Z" transform="rotate(180 16 24)" fill="#992532"></path><path fill="#fff" d="M1 9H31V12H1z"></path><path fill="#fff" d="M1 20H31V23H1z"></path><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
);

const JapaneseFlag = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"><rect x="1" y="4" width="30" height="24" rx="4" ry="4" fill="#fff"></rect><path d="M27,4H5c-2.209,0-4,1.791-4,4V24c0,2.209,1.791,4,4,4H27c2.209,0,4-1.791,4-4V8c0-2.209-1.791-4-4-4Zm3,20c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V8c0-1.654,1.346-3,3-3H27c1.654,0,3,1.346,3,3V24Z" opacity=".15"></path><circle cx="16" cy="16" r="6" fill="#ae232f"></circle><path d="M27,5H5c-1.657,0-3,1.343-3,3v1c0-1.657,1.343-3,3-3H27c1.657,0,3,1.343,3,3v-1c0-1.657-1.343-3-3-3Z" fill="#fff" opacity=".2"></path></svg>
);

const flagContainerStyle = {
  width: '100%',
  height: '100%',
  borderRadius: '50%',
  border: '1px solid rgba(0,0,0,0.1)',
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: '#f8f9fa',
};

const flagStyle = {
  position: 'absolute',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transform: 'scale(1.6)',
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [selected, setSelected] = useState("EN");
  const [isOpen, setIsOpen] = useState(false);

  const countryToLangMap = {
    EN: "en",
    TH: "th",
    JP: "jp",
  };

  useEffect(() => {
    const language = i18n.language;
    const countryCode = Object.keys(countryToLangMap).find(
      (key) => countryToLangMap[key] === language
    );
    setSelected(countryCode || "EN");
  }, [i18n.language]);

  const changeLanguage = (code) => {
    const lang = countryToLangMap[code];
    if (lang) {
      i18n.changeLanguage(lang);
      setSelected(code.toUpperCase());
      setIsOpen(false);
    }
  };

  const LANGUAGES = [
    { label: "EN", code: "en", Flag: EnglishFlag },
    { label: "TH", code: "th", Flag: ThaiFlag },
    { label: "JP", code: "jp", Flag: JapaneseFlag },
  ];

  const getFlagComponent = (code) => {
    const language = LANGUAGES.find(lang => lang.code.toUpperCase() === code);
    return language ? language.Flag : EnglishFlag;
  };

  return (
    <div className="relative mt-2">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-8 h-8 rounded-full focus:outline-none hover:ring-2 hover:ring-emerald-500 transition-all duration-200"
      >
        <div style={flagContainerStyle}>
          <div style={flagStyle}>
            {React.createElement(getFlagComponent(selected))}
          </div>
        </div>
      </button>

      {isOpen && (
        <div className="absolute -right-2.5 mt-2 bg-white rounded-xl shadow-lg z-50 p-2 border border-gray-100 w-[52px]">
          {LANGUAGES.filter(language => language.code.toUpperCase() !== selected).map((language) => (
            <button
              key={language.code}
              onClick={() => changeLanguage(language.code.toUpperCase())}
              className="flex items-center justify-center w-full mb-1 last:mb-0"
            >
              <div className="w-8 h-8">
                <div style={flagContainerStyle}>
                  <div style={flagStyle}>
                    {React.createElement(language.Flag)}
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
